import PropTypes from 'prop-types';
import React from 'react';
import 'src/components/Referrals/stylesheets/referrals.scss';

function Header(props) {
  const {
    header, mainHeader, subHeader, styles,
  } = props;
  return (
    <header className="referral-header" style={styles.container}>
      <h2>{header}</h2>
      {
        (mainHeader) ? (<h3>{mainHeader}</h3>) : null
      }
      <span className="help-block">{subHeader}</span>
    </header>
  );
}

Header.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  mainHeader: PropTypes.string,
  styles: PropTypes.object.isRequired,
};

Header.defaultProps = {
  styles: {
    container: {
      margin: '0px 0px 30px',
    },
  },
};

export default Header;
